import React from 'react';
import overlay1Img from '../assets/images/overlay1.svg';
import overlay2Img from '../assets/images/overlay2.svg';

const BgComponent = () => {
  return (
    <div className='bg'>
      <div className='bg-overlay1 parallax-item'>
        <img src={overlay1Img} alt="Matsutek overlay" />
      </div>
      <div className='bg-overlay2 parallax-item'>
        <img src={overlay2Img} alt="Matsutek overlay"/>
      </div>
    </div>
  );
};

export default BgComponent;
